import { useScreen } from "@hooks";
import { createSlice } from "@reduxjs/toolkit";
import { getDefaultApiUrl, isNgrokUrl } from "@utils";
import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "./hooks";

export type UIState = { sidebarOpen: boolean };

const defaultState: UIState = { sidebarOpen: false };

export const uiSlice = createSlice({
  name: "ui",
  initialState: defaultState,
  reducers: {
    closeSidebar: (state) => {
      state.sidebarOpen = false;
    },
    openSidebar: (state) => {
      state.sidebarOpen = true;
    },
    toggleSidebar: (state) => {
      state.sidebarOpen = !state.sidebarOpen;
    },
  },
});

type UISelectorState = { ui: UIState };
const sidebarOpen = (state: UISelectorState) => state.ui.sidebarOpen;

export const { reducer } = uiSlice;

export const useUI = () => {
  const dispatch = useAppDispatch();
  const { isWide } = useScreen();
  return {
    // Read-only process configuration; no backend target lives in Redux.
    apiURL: getDefaultApiUrl(),
    isNgrokUrl: isNgrokUrl(),
    closeSidebar: useCallback(
      () => !isWide && dispatch(uiSlice.actions.closeSidebar()),
      [dispatch, isWide],
    ),
    openSidebar: useCallback(
      () => dispatch(uiSlice.actions.openSidebar()),
      [dispatch],
    ),
    sidebarOpen: useAppSelector(sidebarOpen),
    toggleSidebar: useCallback(
      () => dispatch(uiSlice.actions.toggleSidebar()),
      [dispatch],
    ),
  };
};
